import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-heap"]
const _hoisted_3 = { class: "counter__selection" }
const _hoisted_4 = { slot: "tooltip-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "price__hide" }
const _hoisted_7 = { class: "m-checkbox" }
const _hoisted_8 = { class: "m-checkbox_content" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_counter = _resolveComponent("joy-counter")!
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_tooltip_trigger = _resolveComponent("joy-tooltip-trigger")!
  const _component_joy_highlight = _resolveComponent("joy-highlight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.details.price.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.details.price.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": _ctx.dataHeapTooltipID,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.price.help')), 9, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_joy_counter, {
        ref: "counter",
        name: "counter",
        "aria-label": _ctx.$msg('profile.creation.completion.wizard.details.price.title'),
        value: _ctx.priceSelected,
        min: _ctx.min,
        max: _ctx.max,
        step: _ctx.steps,
        required: "true",
        "data-testid": "price-input",
        onValueChange: _ctx.changeValue,
        onFocusCapture: _ctx.emitFocus
      }, null, 8, ["aria-label", "value", "min", "max", "step", "onValueChange", "onFocusCapture"]),
      _withDirectives(_createVNode(_component_joy_highlight, {
        class: "counter__selection-earning",
        level: "neutral",
        "data-testid": "priceWithoutFee"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.price.earning')) + " ", 1),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.estimateEarningStandard) + " - " + _toDisplayString(_ctx.estimateEarningReduced) + _toDisplayString(_ctx.currencySymbol), 1)
          ]),
          (!_ctx.mobileSM)
            ? (_openBlock(), _createBlock(_component_joy_tooltip_trigger, {
                key: 0,
                position: "bottom-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_joy_icon, {
                    slot: "tooltip-trigger",
                    name: "info-circle",
                    size: "xsmall"
                  }),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.counterTooltip), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.hasEstimateEarning]
      ]),
      (_ctx.shouldDisplayAverage)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "counter__selection-description",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, [
        _createElementVNode("input", {
          type: "checkbox",
          name: "priceHidden",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePriceHide && _ctx.togglePriceHide(...args)))
        }, null, 32),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$msg('profile.section.header.numeral.hide.price.label')), 1)
      ]),
      _createVNode(_component_joy_highlight, {
        name: "highlight-hide-price",
        level: "info",
        "display-icon": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: _ctx.$msg('profile.section.header.numeral.hide.price.information.text.v2')
          }, null, 8, _hoisted_9)
        ]),
        _: 1
      })
    ])
  ]))
}